<template>
  <section class="approve-checklist">
    <p class="approve-checklist__hint text-body-2 mb-4">
      请对以下事项进行最终检查与确认，确认无误后即可投运：
    </p>
    <div class="approve-checklist__cards d-flex flex-wrap ga-3">
      <button
        v-for="item in items"
        :key="item.key"
        type="button"
        class="approve-checklist__card rounded-lg text-left"
        :class="{ 'approve-checklist__card--active': modelValue === item.key }"
        @click="$emit('update:modelValue', item.key)"
      >
        <div class="approve-checklist__card-head d-flex align-center ga-2 mb-2">
          <span class="approve-checklist__num rounded-circle d-inline-flex align-center justify-center">
            {{ item.step }}
          </span>
          <span class="text-body-2 font-weight-medium">{{ item.title }}:</span>
          <span class="approve-checklist__reviewed text-body-2">
            已查阅
            <v-icon size="16" color="primary">mdi-check</v-icon>
          </span>
        </div>
        <p class="approve-checklist__card-desc text-caption text-medium-emphasis mb-0">
          {{ item.hint }}
        </p>
      </button>
    </div>
  </section>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
})

defineEmits(['update:modelValue'])
</script>

<style scoped lang="scss">
.approve-checklist__hint {
  padding: 12px 14px;
  background: color-mix(in srgb, var(--color-primary) 6%, #f2f5fe);
  border: 1px solid color-mix(in srgb, var(--color-primary) 12%, var(--color-td-border));
  border-radius: 8px;
  color: var(--color-text);
  opacity: 0.92;
  line-height: 1.5;
}

.approve-checklist__card {
  flex: 1 1 160px;
  min-width: 140px;
  max-width: 240px;
  padding: 14px 16px;
  border: 1px solid var(--color-td-border);
  background: rgba(255, 255, 255, 0.96);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.approve-checklist__card:hover {
  border-color: color-mix(in srgb, var(--color-primary) 35%, var(--color-td-border));
  background: #fff;
}

.approve-checklist__card--active {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--color-primary) 25%, transparent);
  background: #fff;
}

.approve-checklist__num {
  width: 22px;
  height: 22px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: var(--color-primary);
  flex-shrink: 0;
}

.approve-checklist__reviewed {
  color: var(--color-primary);
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.approve-checklist__card-desc {
  line-height: 1.45;
  padding-left: 30px;
}

@media (prefers-reduced-motion: reduce) {
  .approve-checklist__card {
    transition: none;
  }
}
</style>
